import { createFileRoute } from '@tanstack/react-router';
import { AdminReportsPage } from '../../features/reporting';

export const Route = createFileRoute('/admin/reports')({ component: AdminReportsPage });
